import React, { useContext } from "react";
import { ProductContext } from "../../context";
import { orders } from './orders';
import { CssPopSection, CSSuikit0, CSSuikitH, CSSuikitSection, ContentBlock, Button, CssPaper, CssFormGroup, CssH1 } from "../uikit-b2c/uikit-b2c";
import { Orders, OrderLine } from "./OrderLine";
export const UserAccountOrders = () => {
  const valueFromContext = useContext(ProductContext);
  return (<React.Fragment>


    <CssFormGroup alignment="center">
      <CssPopSection theme={valueFromContext.getTheme()}>
        <CssFormGroup indentation="md">
          <CssH1>My orders</CssH1>
        </CssFormGroup>
      </CssPopSection>
    </CssFormGroup>



    <CssFormGroup alignment="center">
      <CssPopSection theme={valueFromContext.getTheme()}>

       <Orders
        filter={false}
       />

        {/* {orders['orders'].map((oneOrder, ind) => {
          if (oneOrder && oneOrder['purchase']['virtual_item'] || oneOrder['purchase']['virtual_currency']) {
            return <OrderLine key={`order_${oneOrder['operation_id']}`} purchase={oneOrder['purchase']} filter={false} operation_id={oneOrder['operation_id']} date={oneOrder['date']} />;
          }
          else {
            return null;
          }
        })} */}
      </CssPopSection>
    </CssFormGroup>




    <CssFormGroup alignment="center">
      <CssPopSection theme={valueFromContext.getTheme()}>
        <CssFormGroup style={{
          justifyContent: 'flex-end',
          maxWidth: 640,
          display: 'flex',
          flexDirection: 'row',
        }}>
          <div style={{ marginRight: '8px' }}>
            <Button appearance="ghost" theme={valueFromContext.getTheme()}
              // icon={<span>123</span>}
              icon="113">Return and refund policy</Button>
          </div>
          <Button appearance="ghost" theme={valueFromContext.getTheme()}>Contact support</Button>

        </CssFormGroup>
      </CssPopSection>
    </CssFormGroup>



  </React.Fragment>);
};
